import React from "react";
import { Form, Modal } from "react-bootstrap";

export const MobileFilterModal = ({
  showFilter,
  setShowFilter,
  location,
  setLocation,
  partySize,
  setPartySize,
  bookingType,
  setBookingType,
  sortedLocations,
  sortedPartySizes,
  sortedBookingTypes,
  handleApplyFilter,
}) => {
  return (
    <Modal
      show={showFilter}
      onHide={() => setShowFilter(false)}
      className="modal-filter"
      centered
    >
      <Modal.Header>
        <h5 className="modal-title">FILTER</h5>
        <button className="modal-close" onClick={() => setShowFilter(false)}>
          <i className="fal fa-times"></i>
        </button>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group className="mb-4">
            <label htmlFor="mobile-location">LOCATION</label>
            <select
              id="mobile-location"
              className="form-control custom-select"
              onChange={(e) => setLocation(e.target.value)}
              value={location}
            >
              <option value="all">All Location</option>
              {sortedLocations.map((loc) => (
                <option key={loc.slug} value={loc.slug}>
                  {loc.name}
                </option>
              ))}
            </select>
          </Form.Group>

          <Form.Group className="mb-4">
            <label htmlFor="mobile-party-size">PARTY SIZE</label>
            <select
              id="mobile-party-size"
              className="form-control custom-select"
              onChange={(e) => setPartySize(e.target.value)}
              value={partySize}
            >
              <option value="all">All Size</option>
              {sortedPartySizes.map((size) => (
                <option key={size.slug} value={size.slug}>
                  {size.name}
                </option>
              ))}
            </select>
          </Form.Group>

          <Form.Group className="mb-0">
            <label htmlFor="mobile-booking-type">EVENT TYPE</label>
            <select
              id="mobile-booking-type"
              className="form-control custom-select"
              onChange={(e) => setBookingType(e.target.value)}
              value={bookingType}
            >
              <option value="all">All</option>
              {sortedBookingTypes.map((type) => (
                <option key={type.slug} value={type.slug}>
                  {type.name}
                </option>
              ))}
            </select>
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <button className="btn btn-dark w-50" onClick={handleApplyFilter}>
          APPLY
        </button>
      </Modal.Footer>
    </Modal>
  );
};
